import {I_IQPlayerGallery, I_IQPlayerGalleryWrapper} from "./interfaces";
import ReactDOM from "react-dom";
import React from "react";
import IQPlayerSliderApp from "./iq-player-slider";


/**
 * entry point
 */
export const init = () => {
    const iqPlayerGalleryApp = document.querySelectorAll('[iq-player-gallery]');
    let cnt = 1;
    iqPlayerGalleryApp.forEach(iqPlayerGallery => {
        const iqPlayerGalleryDataId = iqPlayerGallery.getAttribute('data-id');
        //console.log('iqPlayerGalleryDataId ',iqPlayerGalleryDataId);

        const iqPlayerGalleryData = document.querySelectorAll(`[iq-player-gallery-data="${iqPlayerGalleryDataId}"]`);
        if(!iqPlayerGalleryData || !iqPlayerGalleryData[0] || !iqPlayerGalleryData[0].textContent)
            return;
        //console.log('illugenGalleryData[0].textContent: ',illugenGalleryData[0].textContent);
        let iqPlayerGalleryWrapper:I_IQPlayerGalleryWrapper;
        try {
            iqPlayerGalleryWrapper = JSON.parse(iqPlayerGalleryData[0].textContent);
        } catch (ex) {
            console.error("parse error:", ex);
            return;
        }
        if (!iqPlayerGalleryWrapper) return;

        iqPlayerGalleryWrapper.iQPlayerGallery =
            iqPlayerGalleryWrapper.iQPlayerGallery.map((item, index) => ({
                ...item,
                runID: index + 1, //
            }));

        iqPlayerGallery.classList.remove('hidden');

        ReactDOM.render(
            <React.StrictMode>
                <IQPlayerSliderApp iQPlayerGalleryWrapper={iqPlayerGalleryWrapper} elId={cnt++}/>
            </React.StrictMode>,
            iqPlayerGallery
        );
    });

};

/**
 * entry point
 */
document.addEventListener('DOMContentLoaded', () => {
    init();
});